export default __webpack_public_path__ + "static/Plots0105-e2de3cc85f28d02457c950b9cdbad136.jpg";